






















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  ALL_USER_AUTHENTICATED_ROLES_EXCEPT_ANON,
  UserRoles,
} from "@/models/auth/AuthenticatedUser";
import RoleBadge from "@/components/user-management/RoleBadge.vue";

@Component({
  components: { RoleBadge },
})
/**
 * Allow to select a new user role
 */
export default class RoleSelector extends Vue {
  /**
   * The initial selected role
   */
  @Prop({
    required: true,
    type: String,
  })
  value!: UserRoles | undefined;

  /**
   *  Roles can be excluded from the selection
   */
  @Prop({
    required: false,
    type: Array,
  })
  excludedRoles!: UserRoles[] | undefined;

  /**
   * make em available in the template
   */
  public roles = UserRoles;

  /**
   * the selected new role
   */
  public selected: string | undefined = "";

  /**
   * all possible roles to select from
   */
  public allOptions: UserRoles[] = ALL_USER_AUTHENTICATED_ROLES_EXCEPT_ANON;

  /**
   * set the inital role
   */
  mounted(): void {
    this.selected = this.value;
  }

  /**
   * get all available options
   */
  get options(): string[] {
    return this.allOptions.filter((option) => {
      if (option) {
        return !this.excludedRoles?.includes(option);
      } else {
        return true;
      }
    });
  }

  /**
   * update new states
   * @param newRole
   */
  @Watch("value")
  valueChanged(newRole: UserRoles): void {
    if (newRole !== this.selected) {
      this.selected = newRole;
    }
  }

  /**
   * emit state updates
   * @param option
   */
  @Watch("selected")
  selectedChanged(option: UserRoles): void {
    this.$emit("input", option);
  }
}
